export const GENERAL_ERROR = "An error has occurred";
